import { Box } from "@mui/material";
import React, { type FC } from "react";

type Props = {
  children?: React.ReactNode;
  minWidth?: string | number;
};

const ResponsiveTableContainer: FC<Props> = ({ children, minWidth }) => {
  return (
    <Box overflow="auto">
      <Box minWidth={minWidth || "1014px"}>{children}</Box>
    </Box>
  );
};

export default ResponsiveTableContainer;
